import { Formik } from "formik";
import { useStore } from "../../hooks/store";
import { postVideoData, putVideoData } from "../../utils/API/videoMethods";
import Styles from "./Form.module.css";
import CustomField from "../shared/CustomTextField";
import { Button, MenuItem } from "@mui/material";
import VideoUploader from "../VideoUploader";
import AddIcon from "@mui/icons-material/Add";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

import { styled } from "@mui/material/styles";
import { uploaderType } from "../../utils/config";
import { videoValidation } from "../../utils/validation";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});
export default function VideoForm({ themeList }) {
  const store = useStore();
  const videoData = store.form.dataToUpdate;

  const initValues = videoData || {
    // id: undefined,
    name: undefined,
    theme_id: undefined,
    video_src: undefined,
    preview_src: undefined,
    video_length: undefined,
    // res_480: null,
    // res_720: null,
    // res_1080: null,
  };
  const submitBilet = (values) => {
    postVideoData(values).then(({ data, status }) => {
      if (status === 200) {
        store.closeForm();
        store.setAlert(data, "success");
        store.form.callBack();
        return;
      }

      store.setAlert(data, "error");
    });
  };

  const submitUpdatedBilet = (values) => {
    putVideoData(values.id, values).then(({ data, status }) => {
      if (status === 200) {
        store.closeForm();
        store.setAlert(data, "success");
        store.form.callBack();
        return;
      }

      store.setAlert(data, "error");
    });
  };
  return (
    <Formik
      initialValues={{ ...initValues }}
      validationSchema={videoValidation}
      onSubmit={(values, { setSubmitting }) => {
        setSubmitting(true);
        if (videoData) {
          submitUpdatedBilet(values);
        } else {
          submitBilet(values);
        }

        setSubmitting(false);
      }}>
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        handleReset,
        submitForm,
        setFieldValue,
        /* and other goodies */
      }) => (
        <>
          <p>{videoData ? "Изменение видео" : "Добавление видео"}</p>
          <form onSubmit={handleSubmit}>
            <div
              className={Styles.form_content}
              style={{ flexDirection: "row" }}>
              <div className={Styles.form_fields} style={{ height: "100%" }}>
                <VideoUploader
                  error={errors.video_src}
                  helperText={errors.video_src}
                  values={values}
                  endpoint={"video"}
                  type={uploaderType.video}
                  label={"Добавить видео"}
                  onChange={(fileData) => {
                    values.video_src = fileData.finalFilename;
                    // values.video_length = fileData.fileSize;
                    values.duration = fileData.duration;

                    values.res_480 = fileData.compressedVideos["480"];
                    values.res_720 = fileData.compressedVideos["720"];
                    values.res_1080 = fileData.compressedVideos["1080"];
                  }}
                  defaultSrc={
                    values.res_1080 || values.res_720 || values.res_480
                  }
                />
                <CustomField
                  select
                  name="theme_id"
                  id="theme_id"
                  error={errors.theme_id}
                  helperText={errors.theme_id}
                  label={"Тема виедоролика"}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.theme_id}>
                  {themeList.map((theme) => (
                    <MenuItem
                      key={theme.id}
                      value={theme.id}
                      style={{ width: "300px" }}>
                      {theme.theme_number}.
                      {theme.master_theme_id == null
                        ? ""
                        : theme.theme_subnumber}{" "}
                      {theme.name}
                    </MenuItem>
                  ))}
                </CustomField>

                {/* <Button
                  component="label"
                  role={undefined}
                  variant="contained"
                  tabIndex={-1}
                  startIcon={<CloudUploadIcon />}>
                  Добавить первью
                  <VisuallyHiddenInput
                    type="file"
                    onChange={(e) => {
                      console.log(e.target.files[0]);
                    }}
                  />
                </Button> */}
              </div>
              <div className={Styles.form_fields}>
                <VideoUploader
                  values={values}
                  error={errors.preview_src}
                  helperText={errors.preview_src}
                  endpoint={"image/preview"}
                  type={uploaderType.image}
                  label={"Добавить превью "}
                  onChange={(fileData) => {
                    values.preview_src = fileData.finalFilename;
                  }}
                  defaultSrc={values.preview_src}
                />
                <CustomField
                  error={errors.name}
                  helperText={errors.name}
                  name="name"
                  label="Название видео"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.name}
                />
              </div>
            </div>
            <div className="form_actions">
              <Button onClick={handleReset}>Очистить</Button>
              <Button variant="contained" onClick={handleSubmit}>
                Применить
              </Button>
            </div>
          </form>
        </>
      )}
    </Formik>
  );
}
